import { render, staticRenderFns } from "./VoteLeftBar.vue?vue&type=template&id=376bd6c6&scoped=true"
import script from "./VoteLeftBar.vue?vue&type=script&lang=js"
export * from "./VoteLeftBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376bd6c6",
  null
  
)

export default component.exports